import { render, staticRenderFns } from "./stadium_tags.vue?vue&type=template&id=695a3f38&scoped=true&"
import script from "./stadium_tags.vue?vue&type=script&lang=ts&"
export * from "./stadium_tags.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_tags.vue?vue&type=style&index=0&id=695a3f38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a3f38",
  null
  
)

export default component.exports